import { getDomainByLocaleAndHost, initCanonicalLink, initHreflang } from '@bit/utils'
import { Helmet } from '@bit/zeus-ssr/components'
import { useKoaContext } from '@bit/zeus-ssr/hooks'
import React, { useMemo } from 'react'

import { useRouter } from 'src/hook/biz/useRouter'
import { useTranslations } from 'src/hook/biz/useTranslations'
import { formatLocalePath } from 'src/util/formatLocalePath'
import { getCustomHost } from 'src/util/getCustomHost'
import { defaultLocale } from 'src/util/locale'

export const SeoTdk = () => {
  const router = useRouter()
  const pathname = router.pathname
  const t = useTranslations()
  const { locale = defaultLocale } = router
  const title = t('seo.external.title')
  const description = t('seo.external.desc')
  const image = 'https://img.bgstatic.com/video/open_graph_new.png'

  const context = useKoaContext()

  const customHost = getCustomHost(context)

  const canonicalLink = initCanonicalLink({
    locale,
    host: customHost,
    suffix: pathname,
    subdomain: 'affiliates'
  })

  const hreflangList = initHreflang({
    suffix: pathname,
    includeDefault: true,
    ignoreLocales: [],
    subdomain: 'affiliates'
  })

  const canonicalUrl = useMemo(
    () =>
      `${getDomainByLocaleAndHost(locale, customHost, 'affiliates')}${formatLocalePath(locale)}${pathname}`,
    [customHost, locale, pathname]
  )

  return (
    <Helmet>
      {hreflangList.map((item) => {
        return <link key={item.key} rel={item.rel} hrefLang={item.hrefLang} href={item.href} />
      })}
      <link rel={canonicalLink.rel} href={canonicalLink.href} />

      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Bitget Agent" />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />

      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:site" content="@bitgetglobal" />
      <meta property="twitter:image" content={image} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image:alt" content="Bitget-Trade smarter" />
    </Helmet>
  )
}
